import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-dlg-comment-confirm',
    imports: [
        MatDialogModule,
        MatButtonModule,
        ReactiveFormsModule, FormsModule,
        MatInputModule
    ],
    templateUrl: './dlg-comment-confirm.component.html',
    styleUrl: './dlg-comment-confirm.component.scss'
})
export class DlgCommentConfirmComponent {
  constructor(
    public dialogRef: MatDialogRef<any>
  ) { }

  deleteForm = new FormGroup({
    observation: new FormControl("", [
      Validators.required
    ])
  })

  close() {
    this.dialogRef.close(this.deleteForm.controls.observation.value);
  }
}
